import { useProductStore } from '@/stores';

export default defineNuxtRouteMiddleware(async () => {
  if (process.client) return;
  const { loadLanguageConfig } = useProductStore();
  await loadLanguageConfig();
});
